/* Progressive enhancements. Native links and Shopify forms remain functional without JS. */
(() => {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pending = new WeakMap();
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-language]')) event.target.form.requestSubmit();
  });
  document.addEventListener('click', async (event) => {
    const menuLink = event.target.closest('[data-menu] nav a');
    if (menuLink) menuLink.closest('details').open = false;
    const thumb = event.target.closest('[data-gallery-target]');
    if (thumb) {
      const gallery = thumb.closest('[data-gallery]');
      const target = gallery.querySelector('[data-media-id="' + CSS.escape(thumb.dataset.galleryTarget) + '"]');
      if (target) {
        event.preventDefault();
        const track = gallery.querySelector('[data-gallery-track]');
        track.scrollTo({left:target.offsetLeft,behavior:reduced.matches?'instant':'smooth'});
        gallery.querySelectorAll('[data-gallery-target]').forEach(a=>a.removeAttribute('aria-current'));
        thumb.setAttribute('aria-current','true');
      }
    }
    const link = event.target.closest('[data-variant-link]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const section = link.closest('[data-product-section]');
    const info = section && section.querySelector('[data-product-info]');
    if (!section || !info) return;
    event.preventDefault();
    const existing = pending.get(section);
    if (existing) existing.abort();
    const controller = new AbortController();
    pending.set(section,controller);
    info.setAttribute('aria-busy','true');
    const url = new URL(link.href);
    url.searchParams.set('section_id',section.dataset.productSection);
    try {
      const response = await fetch(url,{signal:controller.signal,credentials:'same-origin'});
      if (!response.ok) throw new Error('Variant response failed');
      const page = new DOMParser().parseFromString(await response.text(),'text/html');
      const replacement = page.querySelector('[data-product-info]');
      if (!replacement || !replacement.querySelector('input[name="id"]')) throw new Error('Variant content unavailable');
      if (pending.get(section)!==controller || !section.isConnected) return;
      const selectedId = link.dataset.variantId;
      info.replaceWith(replacement);
      const media = replacement.dataset.featuredMedia;
      if (media) section.querySelector('[data-gallery-target="'+CSS.escape(media)+'"]')?.click();
      url.searchParams.delete('section_id');
      // replaceState preserves the native Back path; native reload restores server state.
      history.replaceState(null,'',url);
      replacement.querySelector('[data-variant-id="'+CSS.escape(selectedId)+'"]')?.focus({preventScroll:true});
    } catch (error) {
      if (error.name !== 'AbortError' && section.isConnected) location.assign(link.href);
    } finally {
      if (pending.get(section)===controller) { pending.delete(section); info.removeAttribute('aria-busy'); }
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const menu = document.querySelector('[data-menu][open]');
      if (menu) {menu.open=false;menu.querySelector('summary').focus();}
      document.querySelectorAll('.filter-disclosure[open]').forEach(d=>d.open=false);
    }
  });
  document.addEventListener('click',event=>{
    document.querySelectorAll('[data-menu][open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});
  });
})();
